// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session_add_box {
    display: flex;
    align-items: center;
    gap: 40px;
    border-radius: 8px;
    margin: 10px;
    padding: 10px;
    background: #fff;
    cursor: pointer;
    height: 75px;
    box-shadow: 0px 0px 5px #0877bc52;
    width: calc(50% - 20px);
}

.exercise_session_div {
    display: flex;
    flex-wrap: wrap;
}

.exercise_type_define {
    font-size: 12px;
    color: #0877BC;
    margin: 10px;

}

.exercise_finalized {
    background-color: #0877BC;
    color: #fff;
    padding: 4px 10px;
    border-radius: 2px;
    border: none;
    font-size: 15px;
}

.ex_add_box {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 16px;
    border-radius: 12px;
    margin: 10px;
    padding: 14px 16px;
    background: var(--brand-surface, #fff);
    cursor: pointer;
    min-height: auto;
    box-shadow: 0 2px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent);
    width: calc(50% - 20px);
    cursor: grab;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);
    transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;
    position: relative;
}

.ex_add_box--with-delete {
    padding-bottom: 52px;
}

/* Redesigned card: main content area */
.ex_add_box__main {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1 1;
    min-width: 0;
}

/* Planning: up/down reorder + order badge */
.ex_add_box__order-wrap {
    flex-shrink: 0;
    gap: 2px;
}

.ex_add_box__order-wrap .MuiIconButton-root {
    color: var(--brand-primary, #0877BC);
}

.ex_add_box__order {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 12%, #fff);
    color: var(--brand-primary, #0877BC);
    font-weight: 700;
    font-size: 13px;
    border-radius: 8px;
}

.ex_add_box__thumb {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-color, #f8fafc);
    border-radius: 10px;
    overflow: hidden;
}

.ex_add_box__thumb img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.ex_add_box__thumb-fallback {
    width: 32px;
    height: 32px;
}

.ex_add_box__content {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.ex_add_box__title-row {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.ex_add_box__title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 1.3;
}

.ex_add_box__subtitle {
    font-size: 13px;
    color: #666;
}

.ex_add_box__select-btn {
    background: none;
    border: none;
    color: #0877BC;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    text-align: left;
}

.ex_add_box__select-btn:hover {
    text-decoration: underline;
}

.ex_add_box__meta {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.ex_add_box__duration {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.ex_add_box__duration-input {
    width: 44px;
    padding: 4px 6px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    font-size: 14px;
    outline: none;
    -moz-appearance: textfield;
    background: var(--bg-color, #fff);
    color: var(--text-color, #111);
}

.ex_add_box__duration-input::-webkit-outer-spin-button,
.ex_add_box__duration-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.ex_add_box__duration-input--editing {
    border-color: var(--brand-primary, #0877BC);
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--bg-color, #fff));
}

.ex_add_box__min {
    font-size: 13px;
    color: var(--text-secondary, #666);
}

.ex_add_box__type-badge {
    display: inline-block;
    padding: 4px 10px;
    max-width: 100%;
    background: linear-gradient(
        135deg,
        var(--brand-secondary, #2E7D32) 0%,
        color-mix(in srgb, var(--brand-secondary, #2E7D32) 82%, black) 100%
    );
    color: #fff;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 72%, black);
    box-shadow: 0 1px 3px color-mix(in srgb, var(--brand-secondary, #2E7D32) 38%, transparent);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
}

/* Selected state - clear visual feedback */
.ex_add_box--selected,
.ex_add_box.selected_box {
    border-color: var(--brand-primary, #0877BC);
    background: linear-gradient(
        to right,
        color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent) 0%,
        var(--brand-surface, #fff) 18%
    );
    box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent);
}

/* Personalized SMART slot — club brand accent */
.ex_add_box--personalized {
    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 55%, var(--border-color, #e2e8f0));
    background: linear-gradient(
        105deg,
        color-mix(in srgb, var(--brand-primary, #0877BC) 14%, var(--surface-color, #fff)) 0%,
        var(--surface-color, #fff) 42%
    );
    box-shadow:
        0 4px 16px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent),
        inset 3px 0 0 var(--brand-primary, #0877BC);
}

.ex_add_box--personalized .ex_add_box__type-badge {
    background: linear-gradient(
        135deg,
        var(--brand-primary, #0877BC) 0%,
        color-mix(in srgb, var(--brand-primary, #0877BC) 78%, black) 100%
    );
    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 72%, black);
    box-shadow: 0 1px 3px color-mix(in srgb, var(--brand-primary, #0877BC) 38%, transparent);
}

.ex_add_box--personalized.ex_add_box--selected {
    border-color: var(--brand-primary, #0877BC);
    box-shadow:
        0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent),
        0 6px 18px color-mix(in srgb, var(--brand-primary, #0877BC) 24%, transparent),
        inset 3px 0 0 var(--brand-primary, #0877BC);
}

.ex_add_box__actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.ex_add_box__delete-corner {
    position: absolute;
    left: 16px;
    bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #d32f2f;
    background: #fff5f5;
    color: #b71c1c;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 4px 10px;
    cursor: pointer;
    z-index: 1;
}

.ex_add_box__delete-corner:hover {
    background: #ffe6e6;
}

.ex_menu_options2 {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 10px;

    .heart {
        color: #e30108
    }

    .chat {
        color: var(--brand-primary, #0877BC);
        font-size: 20px;
    }
}

.fianalized,
.fianalized .exercise_duration_change {
    background-color: #0877BC;
    color: #fff;
}

/* ── Finalized Exercise Card: light branded style ─── */
.ex_add_box--finalized {
    background: linear-gradient(135deg, #f0f8ff 0%, #e8f4fd 100%);
    border: 1.5px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22);
    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
    cursor: pointer;
    padding-bottom: 14px;
    flex-wrap: wrap;
    align-items: flex-start;
    row-gap: 10px;
}

.ex_add_box--finalized .ex_add_box__order {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.10);
    color: var(--brand-primary, #0877BC);
}

.ex_add_box--finalized .ex_add_box__title {
    color: #1a2b3c;
}

.ex_add_box--finalized .ex_add_box__subtitle {
    color: #546e7a;
}

.ex_add_box--finalized .ex_add_box__duration-input {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
    color: var(--brand-primary, #0877BC);
    font-weight: 600;
}

.ex_add_box--finalized .ex_add_box__min {
    color: #78909c;
}

.fianalized .exercise_cb,
.ex_add_box--finalized .ex_add_box__type-badge {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
    color: var(--brand-primary, #0877BC);
    font-weight: 600;
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
    box-shadow: none;
    background-image: none;
}

/* Finalized: compact sequence count pill */
.ex_add_box__seq-count {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    color: var(--brand-primary, #0877BC);
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
    padding: 3px 10px;
    border-radius: 8px;
    white-space: nowrap;
}

.ex_add_box__seq-count svg {
    font-size: 14px;
}

/* Finalized card: main + actions wrap; summary strip below title */
.ex_add_box--finalized .ex_add_box__main {
    flex: 1 1 220px;
    min-width: 0;
    max-width: 100%;
}

.ex_add_box--finalized .ex_add_box__finalized-actions {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
    row-gap: 6px;
}

.ex_add_box__content--finalized {
    gap: 6px;
}

.ex_add_box--finalized .ex_add_box__title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-word;
    line-height: 1.3;
}

.ex_add_box--finalized .ex_add_box__subtitle {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-word;
    line-height: 1.35;
}

.ex_add_box__finalized-strip {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-top: 4px;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
}

.ex_add_box__finalized-strip-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
    flex: 1 1 140px;
}

.ex_add_box__duration-readonly {
    display: inline-flex;
    align-items: baseline;
    gap: 3px;
    font-size: 14px;
    font-weight: 700;
    color: var(--brand-primary, #0877BC);
    flex-shrink: 0;
    line-height: 1.2;
}

.ex_add_box__duration-readonly-unit {
    font-size: 12px;
    font-weight: 600;
    color: #78909c;
    text-transform: lowercase;
}

.ex_add_box__kind-chip {
    display: inline-block;
    max-width: min(220px, 100%);
    padding: 3px 9px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    box-sizing: border-box;
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22);
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
    color: var(--brand-primary, #1565c0);
}

.ex_add_box__seq-chip {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    max-width: min(140px, 100%);
    padding: 2px 8px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    color: #2e7d32;
    background: rgba(46, 125, 50, 0.1);
    border: 1px solid rgba(46, 125, 50, 0.22);
    flex-shrink: 0;
    min-width: 0;
    box-sizing: border-box;
}

.ex_add_box__seq-chip-icon {
    font-size: 14px !important;
    width: 14px !important;
    height: 14px !important;
    flex-shrink: 0;
}

.ex_add_box__seq-chip-num {
    font-variant-numeric: tabular-nums;
}

.ex_add_box__seq-chip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.ex_add_box__status-pill {
    flex-shrink: 0;
    max-width: min(160px, 40%);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #2e7d32;
    background: rgba(46, 125, 50, 0.12);
    padding: 4px 8px;
    border-radius: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.2;
    box-sizing: border-box;
}

/* Planning badges: keep long labels inside chip bounds (all states) */
.ex_add_box__meta {
    min-width: 0;
}

.ex_add_box__type-badge {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    box-sizing: border-box;
}

/* Finalized: prominent action buttons */
.ex_add_box__finalized-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.ex_add_box__action-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 12px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    font-family: var(--brand-font, inherit);
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.ex_add_box__action-btn svg {
    font-size: 16px;
}

.ex_add_box__action-btn--feedback {
    background: var(--brand-primary, #0877BC);
    color: #fff;
}

.ex_add_box__action-btn--feedback:hover {
    background: var(--brand-primary-dark, #065a8f);
}

.ex_add_box__action-btn--summary {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.10);
    color: var(--brand-primary, #0877BC);
}

.ex_add_box__action-btn--summary:hover {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
}

/* Player finalized: single action (slightly wider) */
.ex_add_box__action-btn--player-feedback {
    background: var(--brand-primary, #0877BC);
    color: #fff;
    padding: 6px 14px;
}

.ex_add_box__action-btn--player-feedback:hover {
    background: var(--brand-primary-dark, #065a8f);
}

/* Finalized: completed check mark on order */
.ex_add_box--finalized .ex_add_box__order::after {
    content: "✓";
    position: absolute;
    top: -4px;
    right: -4px;
    width: 14px;
    height: 14px;
    background: #4caf50;
    color: #fff;
    border-radius: 50%;
    font-size: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-weight: 700;
}

.ex_add_box--finalized .ex_add_box__order {
    position: relative;
}

/* Explicit state label (all cards) */
.ex_add_box__state-row {
    margin-top: 4px;
    margin-bottom: 2px;
}
.ex_add_box__state-text {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #546e7a;
}

/* Cancelled: skipped or stopped within grace window */
.ex_add_box--cancelled {
    background: linear-gradient(135deg, #faf8f5 0%, #fff9f0 100%);
    border: 1.5px dashed rgba(191, 108, 44, 0.45);
    box-shadow: 0 2px 8px rgba(191, 108, 44, 0.08);
    cursor: pointer;
}
.ex_add_box--cancelled .ex_add_box__order {
    background: rgba(191, 108, 44, 0.12);
    color: #bf6c2c;
}
.ex_add_box--cancelled .ex_add_box__title {
    color: #5d4037;
}
.ex_add_box--cancelled .ex_add_box__subtitle {
    color: #795548;
}
.ex_add_box--cancelled .ex_add_box__state-text {
    color: #bf6c2c;
}
.ex_add_box--cancelled .ex_add_box__duration-input {
    background-color: rgba(191, 108, 44, 0.06);
    border-color: rgba(191, 108, 44, 0.2);
    color: #6d4c41;
}
.ex_add_box--cancelled .ex_add_box__type-badge {
    background: rgba(191, 108, 44, 0.08);
    color: #bf6c2c;
    border: 1px solid rgba(191, 108, 44, 0.22);
}
.ex_add_box--cancelled .ex_add_box__thumb img {
    opacity: 0.75;
    filter: grayscale(0.25);
}

.selected_box {
    border: 1px solid var(--brand-primary, #0877BC);
}

.running,
.running .exercise_duration_change,
.running .exercise_info {
    background-color: #a62d32 !important;
    color: #fff;
}

.ex_add_box--running .ex_add_box__order {
    background-color: rgba(166, 45, 50, 0.3);
    color: #fff;
}

.running .selectedsession_imgbox,
.running .session_imgbox {
    border: 1px solid #a62d32 !important;
    background-color: #fff;
}

.running .ex-image-add {
    border: 1px solid #a62d32 !important;
}

.running .exercise_cb {
    background-color: #fff;
    color: #a62d32 !important;
    font-weight: 600;
}

.running .session-state {
    background-color: #fff;
    color: #a62d32;
}

.running .ex_menu_options {
    p {
        color: #fff;
        border: 2px solid #fff;
    }
}

/* Enhanced styling for current running exercise */
.ex_add_box.running.current-exercise {
    border: 3px solid #28a745 !important;
    box-shadow: 0px 4px 15px rgba(40, 167, 69, 0.4) !important;
    background: linear-gradient(to right, rgba(40, 167, 69, 0.1) 0%, #fff 5%) !important;
    animation: pulse-border 2s ease-in-out infinite;
}

@keyframes pulse-border {
    0%, 100% {
        box-shadow: 0px 4px 15px rgba(40, 167, 69, 0.4);
    }
    50% {
        box-shadow: 0px 4px 20px rgba(40, 167, 69, 0.6);
    }
}

.current-exercise .exercise-addinfo h4 {
    color: #28a745 !important;
    font-weight: 700 !important;
}

.current-exercise .exercise_types {
    border-top: 2px solid #28a745;
    padding-top: 8px;
    margin-top: 8px;
}

.ex_add_icon {
    color: #fff;
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #0877BC;
    border-radius: 5px;
    font-size: 10px;
}

.ex-image-add {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 8px;
    padding: 5px;
    position: relative;
    min-width: 50px;
    min-height: 50px;
}

.ex-image-add>img {
    width: 40px;
}

.error_msg {
    color: red;
    margin: 10px;
    font-size: 14px;
}

.info_icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.ex_up_box {
    display: flex;
    gap: 50px;
    width: 80%;
    align-items: center;
}

.exercise_info {
    margin-right: 10px;
    color: var(--brand-primary, #0877BC);
}

.exercise-addinfo {
    display: flex;
    flex-direction: column;

    h4 {
        font-size: 13px;
    }
}

.exercise_types {
    display: flex;
    gap: 10px;
    font-size: 15px;
    margin: 5px 0;
}

.select_ex_button {
    color: var(--brand-primary, #0877BC);
}

.exercise_cb {
    background-color: #0877BC;
    padding: 1px 5px;
    color: #fff;
    border-radius: 5px;
    font-size: 12px;
}

.add_button {
    background-color: #0877BC;
    min-width: 120px;
    padding: 7px 12px;
    color: #fff;
    border-radius: 5px;
    font-size: 17px;
    cursor: pointer;
    text-align: center;

}

.exercise_add_center {
    width: 220px;
    height: 100px
}

.exercise_duration_change {
    border: none;
    width: 20px;
    outline: none;
}

.selected_change {
    border: 1px solid #c1c1c1;
}

.ex_menu_options {
    display: flex;
    /* flex-direction: column; */
    gap: 5px;



    p {
        width: 28px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;

        gap: 20px;
        font-size: 12px;
        padding: 0;
        border: 2px solid #0877BC;
        color: var(--brand-primary, #0877BC);
        border-color: var(--brand-primary, #0877BC);
        border-radius: 5px;

        svg {
            font-size: 20px;

        }

    }
}

.invalid {
    margin: 10px 0;
    color: red;
    font-size: 13px;
}

.navwithadd {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.exercise_duration {
    display: flex;
    gap: 10px;

    input {
        width: 45px;
        border: 1px solid #c1c1c1;
        outline: none;
    }
}

.exercise-started {
    margin: 20px 30px;
}

.start_ex_list {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;

}

.table_ex_name {
    border: 1px solid var(--brand-primary, #0877BC);
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 13px;
    color: var(--brand-primary, #0877BC);
    display: flex;
    align-items: center;
    gap: 10px;
    width: 360px;
}

.table_ex_info {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 36px)
}

.selected-ex-add {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border: 2px solid #0877BC;
    border-radius: 8px;
    padding: 3px;

    img {
        width: 30px
    }
}

.table_ex_arrow {
    border: 1px solid var(--brand-primary, #0877BC);
    border-radius: 6px;
    padding: 6px 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: var(--brand-primary, #0877BC);
    cursor: pointer;
}

@media(max-width:1050px) {
    .ex_up_box {
        gap: 30px;
    }

    .ex_menu_options {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

}

/* Compact sequences block inside new card */
.ex_add_box__content .ex_add_box__sequences {
    margin-top: 10px;
    padding: 10px;
    background: var(--bg-color, #f8fafc);
    border-radius: 8px;
    border-left: 4px solid var(--brand-primary, #0877BC);
}

.ex_add_box__sequences-title {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 6px;
    color: var(--text-color, #333);
}

.ex_add_box__seq-item {
    margin-bottom: 6px;
    padding: 8px;
    background: var(--surface-color, #fff);
    border-radius: 6px;
    font-size: 11px;
    border: 1px solid var(--border-color, transparent);
    border-left: 3px solid var(--brand-primary, #1976d2);
    color: var(--text-color);
}

.ex_add_box__seq-item--current {
    background: color-mix(in srgb, #34c759 16%, var(--surface-color, #fff));
    border: 2px solid #34c759;
    border-left: 4px solid #34c759;
    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.25);
}

.ex_add_box__seq-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    gap: 8px;
}

.ex_add_box__seq-item-label {
    font-weight: 500;
    color: var(--brand-primary, #1976d2);
}

.ex_add_box__seq-item--current .ex_add_box__seq-item-label,
.ex_add_box__seq-item--current .ex_add_box__seq-item-meta {
    color: #34c759;
    font-weight: 600;
}

.ex_add_box__seq-item-meta {
    color: var(--text-secondary, #666);
}

.ex_add_box__seq-item-roles {
    display: flex;
    gap: 8px;
    font-size: 10px;
    color: var(--text-secondary, #666);
}

.ex_add_box__seq-item-roles strong {
    color: var(--text-color);
}

.ex_add_box__player-chips {
    margin-top: 8px;
    font-size: 11px;
    color: var(--text-secondary);
}

.ex_add_box__player-chips-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.ex_add_box__player-chip {
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--text-color);
}

.ex_add_box__player-chip--a {
    background: color-mix(in srgb, var(--brand-primary, #1976d2) 16%, var(--surface-color));
}

.ex_add_box__player-chip--b {
    background: color-mix(in srgb, #9c27b0 16%, var(--surface-color));
}

@media(max-width:850px) {

    .session_add_box,
    .ex_add_box {
        width: calc(80% - 20px);
    }

    .ex_menu_options {
        flex-direction: row;

    }


}

@media(max-width:750px) {
    .ex_add_box {
        gap: 20px;
        width: 87%;

    }

    .ex_up_box {
        gap: 40px;
    }

    .ex_menu_options {
        flex-direction: column;
        gap: 4px;

    }

}

@media(max-width:500px) {
    .exercise-started {
        margin: 20px 10px;

    }

    .exercise_add_center {
        width: 0
    }

    .add_button {
        min-width: 50px;
        font-size: 12px;
    }

    .table_ex_name {
        width: 100%
    }

    .session_add_box,
    .ex_add_box {
        width: calc(100% - 20px)
    }


    .exercise_session_div {
        flex-direction: column;
    }

}

@media(max-width:400px) {
    .ex_up_box {
        gap: 20px;
    }

    .ex-image-add>img {
        width: 30px;
    }

    .exercise_types {
        font-size: 12px;
    }

    .exercise_info {
        margin-right: 0;
    }

    .ex_add_box {
        gap: 30px;
        height: max-content;
    }

}

@media(max-width:300px) {
    .exercise_types {
        flex-direction: column;
    }
}

/* ------------------------------------------------------------------------
   Brand color overrides for Planning page action buttons (MUI)
   ------------------------------------------------------------------------ */
.coach-session-page .MuiButton-contained {
    background-color: var(--brand-primary, #0877BC) !important;
    color: #fff !important;
}

.coach-session-page .MuiButton-contained:hover {
    background-color: var(--brand-primary-dark, #065a8f) !important;
}

.coach-session-page .MuiButton-contained.Mui-disabled {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;
    color: rgba(255, 255, 255, 0.85) !important;
}

.coach-session-page .MuiButton-outlined {
    border-color: var(--brand-primary, #0877BC) !important;
    color: var(--brand-primary, #0877BC) !important;
}

.coach-session-page .MuiButton-outlined:hover {
    border-color: var(--brand-primary-dark, #065a8f) !important;
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;
}

.coach-session-page .MuiButton-text {
    color: var(--brand-primary, #0877BC) !important;
}

.coach-session-page .MuiButton-text:hover {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;
}

/* ========================================================================
   Redesigned Exercise Page - Card-based Layout
   ======================================================================== */

.expage-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    gap: 12px;
}

.expage-nav__breadcrumb {
    font-size: 13px;
    color: #0877BC;
    font-weight: 500;
    flex: 1 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.expage-nav__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.expage-nav__count {
    font-size: 13px;
    color: #546e7a;
    font-weight: 600;
    background: #e8f4fc;
    padding: 4px 10px;
    border-radius: 12px;
}

.expage-nav__add-btn {
    background-color: #0877BC;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
}

.expage-nav__add-btn:hover {
    background-color: #065a8c;
}

/* Theme sort selector (add-exercise list) */
.expage-theme-sort {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 16px 12px;
}

.expage-theme-sort__label {
    font-size: 12px;
    font-weight: 650;
    color: var(--text-secondary, #546e7a);
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.expage-theme-sort__chips {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-bottom: 2px;
}

.expage-theme-sort__chips::-webkit-scrollbar {
    display: none;
}

.expage-theme-sort__chip {
    flex: 0 0 auto;
    min-height: 36px;
    padding: 7px 14px;
    border-radius: 999px;
    border: 1px solid var(--border-color, #cfd8dc);
    background: var(--surface-color, #fff);
    color: var(--text-color, #202226);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,
        transform 0.15s ease;
    -webkit-tap-highlight-color: transparent;
}

.expage-theme-sort__chip:active {
    transform: scale(0.97);
}

.expage-theme-sort__chip:focus-visible {
    outline: 2px solid var(--brand-primary, #0877bc);
    outline-offset: 2px;
}

.expage-theme-sort__chip--active {
    background: var(--brand-primary, #0877bc);
    border-color: var(--brand-primary, #0877bc);
    color: #fff;
    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
}

.excard-badge--theme-highlight {
    box-shadow: 0 0 0 2px var(--brand-primary, #0877bc);
    font-weight: 700;
}

.expage-recommend-hint {
    font-size: 12px;
    color: var(--text-secondary, #78909c);
    margin: 0 16px 8px;
    font-style: italic;
}

.expage-grid {
    display: flex;
    flex-wrap: wrap;
    padding: 0 6px;
    gap: 0;
}

/* ── Exercise Card ─────────────────────────────────── */
.excard {
    width: calc(50% - 20px);
    margin: 8px 10px;
    background: var(--surface-color, #fff);
    color: var(--text-color, #1a2b3c);
    border-radius: 14px;
    border: 2px solid transparent;
    box-shadow: 0 2px 10px var(--shadow-color, rgba(8, 119, 188, 0.08));
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.25s, transform 0.15s;
    overflow: hidden;
}

.excard:hover {
    box-shadow: 0 4px 16px var(--shadow-color, rgba(8, 119, 188, 0.14));
    transform: translateY(-1px);
}

.excard--selected {
    border-color: var(--brand-primary, #0877BC);
    background: linear-gradient(
      135deg,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 0%,
      var(--surface-color, #fff) 40%
    );
    box-shadow: 0 4px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
}

/* Header */
.excard-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 14px 14px 10px;
    gap: 10px;
}

.excard-header__left {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex: 1 1;
    min-width: 0;
}

.excard-header__img {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--text-color, #1a2b3c) 6%, var(--surface-color, #f5f8fa));
    border-radius: 10px;
    overflow: hidden;
}

.excard-header__img--mark {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    padding: 3px;
    box-sizing: border-box;
    background: color-mix(
        in srgb,
        var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,
        #ffffff
    );
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);
}

.dark-mode .excard-header__img--mark,
html[data-theme="dark"] .excard-header__img--mark {
    background: color-mix(
        in srgb,
        var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,
        #1f2937
    );
}

.excard-header__img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.excard-header__info {
    flex: 1 1;
    min-width: 0;
}

.excard-header__name {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-color, #1a2b3c);
    margin: 0 0 4px;
    line-height: 1.3;
    word-wrap: break-word;
}

.excard-header__desc {
    font-size: 12px;
    color: var(--text-secondary, #607d8b);
    line-height: 1.4;
    margin: 0 0 6px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.excard-header__type-row {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
}

.excard-header__right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
}

.excard-header__duration {
    display: flex;
    align-items: center;
    gap: 4px;
}

.excard-header__duration-icon {
    color: var(--text-secondary, #90a4ae);
    flex-shrink: 0;
}

.excard-header__duration-input {
    width: 40px;
    padding: 3px 5px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 6px;
    font-size: 13px;
    text-align: center;
    outline: none;
    transition: border-color 0.2s;
    background: var(--surface-color, #fff);
    color: var(--text-color, #1a2b3c);
}

.excard-header__duration-input:focus {
    border-color: var(--brand-primary, #0877BC);
    background: var(--bg-color, #f8fcff);
}

.excard-header__duration-unit {
    font-size: 12px;
    color: var(--text-secondary, #90a4ae);
}

.excard-header__select-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--border-color, #cfd8dc);
    border-radius: 8px;
    background: var(--surface-color, #fff);
    color: var(--text-secondary, #90a4ae);
    cursor: pointer;
    transition: all 0.2s;
}

.excard-header__select-btn svg {
    font-size: 18px;
}

.excard-header__select-btn--active {
    border-color: #0877BC;
    background: #0877BC;
    color: #fff;
}

/* Tags (Type / Subtype / Cardio) */
.excard-tag {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
}

.excard-tag--type {
    background: #e3f2fd;
    color: #1565c0;
}

.excard-tag--subtype {
    background: color-mix(in srgb, var(--brand-secondary, #2E7D32) 16%, #fff);
    color: color-mix(in srgb, var(--brand-secondary, #2E7D32) 82%, black);
    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 44%, transparent);
}

.excard-tag--cardio {
    background: #fff3e0;
    color: #e65100;
    gap: 4px;
}

.excard-tag--cb {
    background: color-mix(in srgb, var(--brand-secondary, #2E7D32) 22%, #fff);
    color: color-mix(in srgb, var(--brand-secondary, #2E7D32) 85%, black);
    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 50%, transparent);
}

/* Sections (Objective, Focus) */
.excard-section {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 0 14px 8px;
}

.excard-section__icon {
    font-size: 16px !important;
    color: var(--text-secondary, #78909c);
    margin-top: 2px;
    flex-shrink: 0;
}

.excard-section--objective .excard-section__icon {
    color: #1565c0;
}

.excard-section--focus .excard-section__icon {
    color: #e65100;
}

.excard-section__text {
    font-size: 12px;
    color: var(--text-secondary, #546e7a);
    line-height: 1.5;
    margin: 0;
}

.excard-section--objective .excard-section__text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.excard-section__focus-item {
    margin: 0 0 2px;
    padding-left: 10px;
    position: relative;
    font-size: 12px;
    color: var(--text-secondary, #546e7a);
    line-height: 1.5;
}

.excard-section__focus-item::before {
    content: "•";
    position: absolute;
    left: 0;
    color: #e65100;
    font-weight: 700;
}

/* Rows (Themes, Skills, Focus) */
.excard-row {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    padding: 0 14px 8px;
}

.excard-row__icon {
    font-size: 15px !important;
    color: var(--text-secondary, #78909c);
    margin-top: 3px;
    flex-shrink: 0;
}

.excard-row--themes .excard-row__icon {
    color: #5c6bc0;
}

.excard-row--skills .excard-row__icon {
    color: #26a69a;
}

.excard-row--focus .excard-row__icon {
    color: #e65100;
}

.excard-row__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

/* Badges */
.excard-badge {
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    font-weight: 600;
    border-radius: 10px;
    overflow: hidden;
    line-height: 1.2;
}

.excard-badge--theme {
    border: 1.5px solid #90caf9;
    background: #f5f8fc;
}

.excard-badge--theme .excard-badge__label {
    padding: 2px 6px;
    color: #37474f;
}

.excard-badge--theme .excard-badge__level {
    padding: 2px 6px;
    color: #fff;
    font-weight: 700;
    font-size: 10px;
}

.excard-badge--skill {
    background: #e0f2f1;
    color: #00695c;
    padding: 3px 8px;
    border: 1px solid #b2dfdb;
}

.excard-badge--focus {
    background: #fff3e0;
    color: #bf360c;
    padding: 3px 8px;
    border: 1px solid #ffcc80;
}

/* Cardio dots */
.excard-cardio {
    display: flex;
    gap: 2px;
    align-items: center;
}

.excard-cardio__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #e0e0e0;
    transition: background-color 0.2s;
}

.excard-cardio__dot--filled {
    background: #ff9800;
}

/* Expandable instruction */
.excard-expand {
    border-top: 1px solid var(--border-color, #f0f0f0);
    margin: 0 14px;
    padding: 6px 0 10px;
}

.excard-expand__toggle {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    color: var(--brand-primary, #0877BC);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 2px 0;
}

.excard-expand__toggle:hover {
    text-decoration: underline;
}

.excard-expand__content {
    font-size: 12px;
    color: var(--text-secondary, #546e7a);
    line-height: 1.6;
    margin: 6px 0 0;
    padding: 8px 10px;
    background: var(--bg-color, #f8fafb);
    border-radius: 8px;
    border-left: 3px solid var(--brand-primary, #0877BC);
}

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 900px) {
    .excard {
        width: calc(100% - 20px);
    }
}

@media (max-width: 500px) {
    .expage-nav {
        flex-wrap: wrap;
        padding: 8px 10px;
    }

    .expage-nav__breadcrumb {
        width: 100%;
        margin-bottom: 4px;
    }

    .expage-grid {
        padding: 0 2px;
    }

    .excard {
        width: calc(100% - 8px);
        margin: 6px 4px;
    }

    .excard-header {
        padding: 10px 10px 8px;
        flex-wrap: wrap;
    }

    .excard-header__right {
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
        margin-top: 4px;
    }

    .excard-section,
    .excard-row,
    .excard-expand {
        padding-left: 10px;
        padding-right: 10px;
    }

    .excard-expand {
        margin: 0 10px;
    }

    .excard-header__name {
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Exerciseadd/Exercise.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,yFAAyF;IACzF,uBAAuB;IACvB,YAAY;IACZ,oFAAoF;IACpF,qEAAqE;IACrE,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA,4CAA4C;AAC5C;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uEAAuE;IACvE,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,2CAA2C;IAC3C,wFAAwF;AAC5F;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf;;;;KAIC;IACD,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gFAAgF;IAChF,0FAA0F;IAC1F,0CAA0C;AAC9C;;AAEA,2CAA2C;AAC3C;;IAEI,2CAA2C;IAC3C;;;;KAIC;IACD,yFAAyF;AAC7F;;AAEA,gDAAgD;AAChD;IACI,iGAAiG;IACjG;;;;KAIC;IACD;;mDAE+C;AACnD;;AAEA;IACI;;;;KAIC;IACD,0EAA0E;IAC1E,wFAAwF;AAC5F;;AAEA;IACI,2CAA2C;IAC3C;;;mDAG+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;;IAEnB;QACI;IACJ;;IAEA;QACI,oCAAoC;QACpC,eAAe;IACnB;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA,wDAAwD;AACxD;IACI,6DAA6D;IAC7D,qEAAqE;IACrE,uEAAuE;IACvE,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6DAA6D;IAC7D,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mEAAmE;IACnE,+DAA+D;IAC/D,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,6DAA6D;IAC7D,oCAAoC;IACpC,gBAAgB;IAChB,mEAAmE;IACnE,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,2CAA2C;AAC3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,mEAAmE;AACnE;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,mEAAmE;IACnE,4DAA4D;IAC5D,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,yCAAyC;IACzC,cAAc;IACd,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,sEAAsE;AACtE;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,oCAAoC;AACxC;;AAEA;IACI,6DAA6D;AACjE;;AAEA,qDAAqD;AACrD;IACI,yCAAyC;IACzC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,8CAA8C;AAClD;;AAEA,6CAA6C;AAC7C;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,sDAAsD;AACtD;IACI,6DAA6D;IAC7D,6CAA6C;IAC7C,8CAA8C;IAC9C,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;;IAGI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA,kDAAkD;AAClD;IACI,oCAAoC;IACpC,0DAA0D;IAC1D,oFAAoF;IACpF,+CAA+C;AACnD;;AAEA;IACI;QACI,+CAA+C;IACnD;IACA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,QAAQ;;;;IAIR;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB,SAAS;QACT,eAAe;QACf,UAAU;QACV,yBAAyB;QACzB,oCAAoC;QACpC,2CAA2C;QAC3C,kBAAkB;;QAElB;YACI,eAAe;;QAEnB;;IAEJ;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;;IAET;QACI,WAAW;QACX,yBAAyB;QACzB,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;;IAEZ;QACI;IACJ;AACJ;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;AAEJ;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,kDAAkD;IAClD,oDAAoD;IACpD,wBAAwB;AAC5B;;AAEA;IACI,uEAAuE;IACvE,yBAAyB;IACzB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,iEAAiE;AACrE;;AAEA;;IAEI;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;;IAEvB;;;AAGJ;;AAEA;IACI;QACI,SAAS;QACT,UAAU;;IAEd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,QAAQ;;IAEZ;;AAEJ;;AAEA;IACI;QACI,iBAAiB;;IAErB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;;IAGA;QACI,sBAAsB;IAC1B;;AAEJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;6EAE6E;AAC7E;IACI,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,8EAA8E;IAC9E,2CAA2C;AAC/C;;AAEA;IACI,sDAAsD;IACtD,+CAA+C;AACnD;;AAEA;IACI,2DAA2D;IAC3D,8EAA8E;AAClF;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8EAA8E;AAClF;;AAEA;;6EAE6E;;AAE7E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,8CAA8C;IAC9C,sCAAsC;IACtC,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;4BACwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,2CAA2C;IAC3C,WAAW;IACX,uEAAuE;AAC3E;;AAEA;IACI,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,MAAM;AACV;;AAEA,yDAAyD;AACzD;IACI,uBAAuB;IACvB,gBAAgB;IAChB,sCAAsC;IACtC,iCAAiC;IACjC,mBAAmB;IACnB,6BAA6B;IAC7B,mEAAmE;IACnE,eAAe;IACf,gEAAgE;IAChE,gBAAgB;AACpB;;AAEA;IACI,mEAAmE;IACnE,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C;;;;KAIC;IACD,wEAAwE;AAC5E;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4FAA4F;IAC5F,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB;;;;KAIC;IACD,oFAAoF;AACxF;;AAEA;;IAEI;;;;KAIC;AACL;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;IAC9C,kBAAkB;IAClB,sCAAsC;IACtC,qCAAqC;IACrC,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yEAAyE;IACzE,qEAAqE;IACrE,sFAAsF;AAC1F;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,yEAAyE;IACzE,qEAAqE;IACrE,sFAAsF;AAC1F;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA,WAAW;AACX;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,kDAAkD;IAClD,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA,0DAA0D;AAC1D;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,WAAW;QACX,yBAAyB;QACzB,eAAe;IACnB;;IAEA;;;QAGI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".session_add_box {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    border-radius: 8px;\n    margin: 10px;\n    padding: 10px;\n    background: #fff;\n    cursor: pointer;\n    height: 75px;\n    box-shadow: 0px 0px 5px #0877bc52;\n    width: calc(50% - 20px);\n}\n\n.exercise_session_div {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.exercise_type_define {\n    font-size: 12px;\n    color: #0877BC;\n    margin: 10px;\n\n}\n\n.exercise_finalized {\n    background-color: #0877BC;\n    color: #fff;\n    padding: 4px 10px;\n    border-radius: 2px;\n    border: none;\n    font-size: 15px;\n}\n\n.ex_add_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 16px;\n    border-radius: 12px;\n    margin: 10px;\n    padding: 14px 16px;\n    background: var(--brand-surface, #fff);\n    cursor: pointer;\n    min-height: auto;\n    box-shadow: 0 2px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent);\n    width: calc(50% - 20px);\n    cursor: grab;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);\n    transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;\n    position: relative;\n}\n\n.ex_add_box--with-delete {\n    padding-bottom: 52px;\n}\n\n/* Redesigned card: main content area */\n.ex_add_box__main {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex: 1;\n    min-width: 0;\n}\n\n/* Planning: up/down reorder + order badge */\n.ex_add_box__order-wrap {\n    flex-shrink: 0;\n    gap: 2px;\n}\n\n.ex_add_box__order-wrap .MuiIconButton-root {\n    color: var(--brand-primary, #0877BC);\n}\n\n.ex_add_box__order {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 12%, #fff);\n    color: var(--brand-primary, #0877BC);\n    font-weight: 700;\n    font-size: 13px;\n    border-radius: 8px;\n}\n\n.ex_add_box__thumb {\n    flex-shrink: 0;\n    width: 52px;\n    height: 52px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--bg-color, #f8fafc);\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.ex_add_box__thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.ex_add_box__thumb-fallback {\n    width: 32px;\n    height: 32px;\n}\n\n.ex_add_box__content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.ex_add_box__title-row {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.ex_add_box__title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1a1a1a;\n    line-height: 1.3;\n}\n\n.ex_add_box__subtitle {\n    font-size: 13px;\n    color: #666;\n}\n\n.ex_add_box__select-btn {\n    background: none;\n    border: none;\n    color: #0877BC;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n    text-align: left;\n}\n\n.ex_add_box__select-btn:hover {\n    text-decoration: underline;\n}\n\n.ex_add_box__meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.ex_add_box__duration {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.ex_add_box__duration-input {\n    width: 44px;\n    padding: 4px 6px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    -moz-appearance: textfield;\n    background: var(--bg-color, #fff);\n    color: var(--text-color, #111);\n}\n\n.ex_add_box__duration-input::-webkit-outer-spin-button,\n.ex_add_box__duration-input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.ex_add_box__duration-input--editing {\n    border-color: var(--brand-primary, #0877BC);\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--bg-color, #fff));\n}\n\n.ex_add_box__min {\n    font-size: 13px;\n    color: var(--text-secondary, #666);\n}\n\n.ex_add_box__type-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    max-width: 100%;\n    background: linear-gradient(\n        135deg,\n        var(--brand-secondary, #2E7D32) 0%,\n        color-mix(in srgb, var(--brand-secondary, #2E7D32) 82%, black) 100%\n    );\n    color: #fff;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.25;\n    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 72%, black);\n    box-shadow: 0 1px 3px color-mix(in srgb, var(--brand-secondary, #2E7D32) 38%, transparent);\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);\n}\n\n/* Selected state - clear visual feedback */\n.ex_add_box--selected,\n.ex_add_box.selected_box {\n    border-color: var(--brand-primary, #0877BC);\n    background: linear-gradient(\n        to right,\n        color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent) 0%,\n        var(--brand-surface, #fff) 18%\n    );\n    box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent);\n}\n\n/* Personalized SMART slot — club brand accent */\n.ex_add_box--personalized {\n    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 55%, var(--border-color, #e2e8f0));\n    background: linear-gradient(\n        105deg,\n        color-mix(in srgb, var(--brand-primary, #0877BC) 14%, var(--surface-color, #fff)) 0%,\n        var(--surface-color, #fff) 42%\n    );\n    box-shadow:\n        0 4px 16px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent),\n        inset 3px 0 0 var(--brand-primary, #0877BC);\n}\n\n.ex_add_box--personalized .ex_add_box__type-badge {\n    background: linear-gradient(\n        135deg,\n        var(--brand-primary, #0877BC) 0%,\n        color-mix(in srgb, var(--brand-primary, #0877BC) 78%, black) 100%\n    );\n    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 72%, black);\n    box-shadow: 0 1px 3px color-mix(in srgb, var(--brand-primary, #0877BC) 38%, transparent);\n}\n\n.ex_add_box--personalized.ex_add_box--selected {\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow:\n        0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent),\n        0 6px 18px color-mix(in srgb, var(--brand-primary, #0877BC) 24%, transparent),\n        inset 3px 0 0 var(--brand-primary, #0877BC);\n}\n\n.ex_add_box__actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.ex_add_box__delete-corner {\n    position: absolute;\n    left: 16px;\n    bottom: 12px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: 1px solid #d32f2f;\n    background: #fff5f5;\n    color: #b71c1c;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 4px 10px;\n    cursor: pointer;\n    z-index: 1;\n}\n\n.ex_add_box__delete-corner:hover {\n    background: #ffe6e6;\n}\n\n.ex_menu_options2 {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #fff;\n    border-radius: 10px;\n\n    .heart {\n        color: #e30108\n    }\n\n    .chat {\n        color: var(--brand-primary, #0877BC);\n        font-size: 20px;\n    }\n}\n\n.fianalized,\n.fianalized .exercise_duration_change {\n    background-color: #0877BC;\n    color: #fff;\n}\n\n/* ── Finalized Exercise Card: light branded style ─── */\n.ex_add_box--finalized {\n    background: linear-gradient(135deg, #f0f8ff 0%, #e8f4fd 100%);\n    border: 1.5px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22);\n    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n    cursor: pointer;\n    padding-bottom: 14px;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    row-gap: 10px;\n}\n\n.ex_add_box--finalized .ex_add_box__order {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.10);\n    color: var(--brand-primary, #0877BC);\n}\n\n.ex_add_box--finalized .ex_add_box__title {\n    color: #1a2b3c;\n}\n\n.ex_add_box--finalized .ex_add_box__subtitle {\n    color: #546e7a;\n}\n\n.ex_add_box--finalized .ex_add_box__duration-input {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n    color: var(--brand-primary, #0877BC);\n    font-weight: 600;\n}\n\n.ex_add_box--finalized .ex_add_box__min {\n    color: #78909c;\n}\n\n.fianalized .exercise_cb,\n.ex_add_box--finalized .ex_add_box__type-badge {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n    color: var(--brand-primary, #0877BC);\n    font-weight: 600;\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n    box-shadow: none;\n    background-image: none;\n}\n\n/* Finalized: compact sequence count pill */\n.ex_add_box__seq-count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--brand-primary, #0877BC);\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n    padding: 3px 10px;\n    border-radius: 8px;\n    white-space: nowrap;\n}\n\n.ex_add_box__seq-count svg {\n    font-size: 14px;\n}\n\n/* Finalized card: main + actions wrap; summary strip below title */\n.ex_add_box--finalized .ex_add_box__main {\n    flex: 1 1 220px;\n    min-width: 0;\n    max-width: 100%;\n}\n\n.ex_add_box--finalized .ex_add_box__finalized-actions {\n    flex: 0 1 auto;\n    min-width: 0;\n    max-width: 100%;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    row-gap: 6px;\n}\n\n.ex_add_box__content--finalized {\n    gap: 6px;\n}\n\n.ex_add_box--finalized .ex_add_box__title {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    word-break: break-word;\n    line-height: 1.3;\n}\n\n.ex_add_box--finalized .ex_add_box__subtitle {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    word-break: break-word;\n    line-height: 1.35;\n}\n\n.ex_add_box__finalized-strip {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: 4px;\n    min-width: 0;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.ex_add_box__finalized-strip-main {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n    min-width: 0;\n    flex: 1 1 140px;\n}\n\n.ex_add_box__duration-readonly {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 3px;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--brand-primary, #0877BC);\n    flex-shrink: 0;\n    line-height: 1.2;\n}\n\n.ex_add_box__duration-readonly-unit {\n    font-size: 12px;\n    font-weight: 600;\n    color: #78909c;\n    text-transform: lowercase;\n}\n\n.ex_add_box__kind-chip {\n    display: inline-block;\n    max-width: min(220px, 100%);\n    padding: 3px 9px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.25;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle;\n    box-sizing: border-box;\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22);\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n    color: var(--brand-primary, #1565c0);\n}\n\n.ex_add_box__seq-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    max-width: min(140px, 100%);\n    padding: 2px 8px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.2;\n    color: #2e7d32;\n    background: rgba(46, 125, 50, 0.1);\n    border: 1px solid rgba(46, 125, 50, 0.22);\n    flex-shrink: 0;\n    min-width: 0;\n    box-sizing: border-box;\n}\n\n.ex_add_box__seq-chip-icon {\n    font-size: 14px !important;\n    width: 14px !important;\n    height: 14px !important;\n    flex-shrink: 0;\n}\n\n.ex_add_box__seq-chip-num {\n    font-variant-numeric: tabular-nums;\n}\n\n.ex_add_box__seq-chip-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.ex_add_box__status-pill {\n    flex-shrink: 0;\n    max-width: min(160px, 40%);\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #2e7d32;\n    background: rgba(46, 125, 50, 0.12);\n    padding: 4px 8px;\n    border-radius: 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.2;\n    box-sizing: border-box;\n}\n\n/* Planning badges: keep long labels inside chip bounds (all states) */\n.ex_add_box__meta {\n    min-width: 0;\n}\n\n.ex_add_box__type-badge {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle;\n    box-sizing: border-box;\n}\n\n/* Finalized: prominent action buttons */\n.ex_add_box__finalized-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.ex_add_box__action-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 6px 12px;\n    border-radius: 10px;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: var(--brand-font, inherit);\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.ex_add_box__action-btn svg {\n    font-size: 16px;\n}\n\n.ex_add_box__action-btn--feedback {\n    background: var(--brand-primary, #0877BC);\n    color: #fff;\n}\n\n.ex_add_box__action-btn--feedback:hover {\n    background: var(--brand-primary-dark, #065a8f);\n}\n\n.ex_add_box__action-btn--summary {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.10);\n    color: var(--brand-primary, #0877BC);\n}\n\n.ex_add_box__action-btn--summary:hover {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n}\n\n/* Player finalized: single action (slightly wider) */\n.ex_add_box__action-btn--player-feedback {\n    background: var(--brand-primary, #0877BC);\n    color: #fff;\n    padding: 6px 14px;\n}\n\n.ex_add_box__action-btn--player-feedback:hover {\n    background: var(--brand-primary-dark, #065a8f);\n}\n\n/* Finalized: completed check mark on order */\n.ex_add_box--finalized .ex_add_box__order::after {\n    content: \"✓\";\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    width: 14px;\n    height: 14px;\n    background: #4caf50;\n    color: #fff;\n    border-radius: 50%;\n    font-size: 9px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n    font-weight: 700;\n}\n\n.ex_add_box--finalized .ex_add_box__order {\n    position: relative;\n}\n\n/* Explicit state label (all cards) */\n.ex_add_box__state-row {\n    margin-top: 4px;\n    margin-bottom: 2px;\n}\n.ex_add_box__state-text {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: #546e7a;\n}\n\n/* Cancelled: skipped or stopped within grace window */\n.ex_add_box--cancelled {\n    background: linear-gradient(135deg, #faf8f5 0%, #fff9f0 100%);\n    border: 1.5px dashed rgba(191, 108, 44, 0.45);\n    box-shadow: 0 2px 8px rgba(191, 108, 44, 0.08);\n    cursor: pointer;\n}\n.ex_add_box--cancelled .ex_add_box__order {\n    background: rgba(191, 108, 44, 0.12);\n    color: #bf6c2c;\n}\n.ex_add_box--cancelled .ex_add_box__title {\n    color: #5d4037;\n}\n.ex_add_box--cancelled .ex_add_box__subtitle {\n    color: #795548;\n}\n.ex_add_box--cancelled .ex_add_box__state-text {\n    color: #bf6c2c;\n}\n.ex_add_box--cancelled .ex_add_box__duration-input {\n    background-color: rgba(191, 108, 44, 0.06);\n    border-color: rgba(191, 108, 44, 0.2);\n    color: #6d4c41;\n}\n.ex_add_box--cancelled .ex_add_box__type-badge {\n    background: rgba(191, 108, 44, 0.08);\n    color: #bf6c2c;\n    border: 1px solid rgba(191, 108, 44, 0.22);\n}\n.ex_add_box--cancelled .ex_add_box__thumb img {\n    opacity: 0.75;\n    filter: grayscale(0.25);\n}\n\n.selected_box {\n    border: 1px solid var(--brand-primary, #0877BC);\n}\n\n.running,\n.running .exercise_duration_change,\n.running .exercise_info {\n    background-color: #a62d32 !important;\n    color: #fff;\n}\n\n.ex_add_box--running .ex_add_box__order {\n    background-color: rgba(166, 45, 50, 0.3);\n    color: #fff;\n}\n\n.running .selectedsession_imgbox,\n.running .session_imgbox {\n    border: 1px solid #a62d32 !important;\n    background-color: #fff;\n}\n\n.running .ex-image-add {\n    border: 1px solid #a62d32 !important;\n}\n\n.running .exercise_cb {\n    background-color: #fff;\n    color: #a62d32 !important;\n    font-weight: 600;\n}\n\n.running .session-state {\n    background-color: #fff;\n    color: #a62d32;\n}\n\n.running .ex_menu_options {\n    p {\n        color: #fff;\n        border: 2px solid #fff;\n    }\n}\n\n/* Enhanced styling for current running exercise */\n.ex_add_box.running.current-exercise {\n    border: 3px solid #28a745 !important;\n    box-shadow: 0px 4px 15px rgba(40, 167, 69, 0.4) !important;\n    background: linear-gradient(to right, rgba(40, 167, 69, 0.1) 0%, #fff 5%) !important;\n    animation: pulse-border 2s ease-in-out infinite;\n}\n\n@keyframes pulse-border {\n    0%, 100% {\n        box-shadow: 0px 4px 15px rgba(40, 167, 69, 0.4);\n    }\n    50% {\n        box-shadow: 0px 4px 20px rgba(40, 167, 69, 0.6);\n    }\n}\n\n.current-exercise .exercise-addinfo h4 {\n    color: #28a745 !important;\n    font-weight: 700 !important;\n}\n\n.current-exercise .exercise_types {\n    border-top: 2px solid #28a745;\n    padding-top: 8px;\n    margin-top: 8px;\n}\n\n.ex_add_icon {\n    color: #fff;\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    background-color: #0877BC;\n    border-radius: 5px;\n    font-size: 10px;\n}\n\n.ex-image-add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n    border: none;\n    border-radius: 8px;\n    padding: 5px;\n    position: relative;\n    min-width: 50px;\n    min-height: 50px;\n}\n\n.ex-image-add>img {\n    width: 40px;\n}\n\n.error_msg {\n    color: red;\n    margin: 10px;\n    font-size: 14px;\n}\n\n.info_icon {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n}\n\n.ex_up_box {\n    display: flex;\n    gap: 50px;\n    width: 80%;\n    align-items: center;\n}\n\n.exercise_info {\n    margin-right: 10px;\n    color: var(--brand-primary, #0877BC);\n}\n\n.exercise-addinfo {\n    display: flex;\n    flex-direction: column;\n\n    h4 {\n        font-size: 13px;\n    }\n}\n\n.exercise_types {\n    display: flex;\n    gap: 10px;\n    font-size: 15px;\n    margin: 5px 0;\n}\n\n.select_ex_button {\n    color: var(--brand-primary, #0877BC);\n}\n\n.exercise_cb {\n    background-color: #0877BC;\n    padding: 1px 5px;\n    color: #fff;\n    border-radius: 5px;\n    font-size: 12px;\n}\n\n.add_button {\n    background-color: #0877BC;\n    min-width: 120px;\n    padding: 7px 12px;\n    color: #fff;\n    border-radius: 5px;\n    font-size: 17px;\n    cursor: pointer;\n    text-align: center;\n\n}\n\n.exercise_add_center {\n    width: 220px;\n    height: 100px\n}\n\n.exercise_duration_change {\n    border: none;\n    width: 20px;\n    outline: none;\n}\n\n.selected_change {\n    border: 1px solid #c1c1c1;\n}\n\n.ex_menu_options {\n    display: flex;\n    /* flex-direction: column; */\n    gap: 5px;\n\n\n\n    p {\n        width: 28px;\n        height: 28px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        gap: 20px;\n        font-size: 12px;\n        padding: 0;\n        border: 2px solid #0877BC;\n        color: var(--brand-primary, #0877BC);\n        border-color: var(--brand-primary, #0877BC);\n        border-radius: 5px;\n\n        svg {\n            font-size: 20px;\n\n        }\n\n    }\n}\n\n.invalid {\n    margin: 10px 0;\n    color: red;\n    font-size: 13px;\n}\n\n.navwithadd {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.exercise_duration {\n    display: flex;\n    gap: 10px;\n\n    input {\n        width: 45px;\n        border: 1px solid #c1c1c1;\n        outline: none;\n    }\n}\n\n.exercise-started {\n    margin: 20px 30px;\n}\n\n.start_ex_list {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.table_ex_name {\n    border: 1px solid var(--brand-primary, #0877BC);\n    border-radius: 6px;\n    padding: 8px 10px;\n    font-size: 13px;\n    color: var(--brand-primary, #0877BC);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 360px;\n}\n\n.table_ex_info {\n    display: flex;\n    justify-content: space-between;\n    width: calc(100% - 36px)\n}\n\n.selected-ex-add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    border: 2px solid #0877BC;\n    border-radius: 8px;\n    padding: 3px;\n\n    img {\n        width: 30px\n    }\n}\n\n.table_ex_arrow {\n    border: 1px solid var(--brand-primary, #0877BC);\n    border-radius: 6px;\n    padding: 6px 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    background-color: var(--brand-primary, #0877BC);\n    cursor: pointer;\n}\n\n@media(max-width:1050px) {\n    .ex_up_box {\n        gap: 30px;\n    }\n\n    .ex_menu_options {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n}\n\n/* Compact sequences block inside new card */\n.ex_add_box__content .ex_add_box__sequences {\n    margin-top: 10px;\n    padding: 10px;\n    background: var(--bg-color, #f8fafc);\n    border-radius: 8px;\n    border-left: 4px solid var(--brand-primary, #0877BC);\n}\n\n.ex_add_box__sequences-title {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: var(--text-color, #333);\n}\n\n.ex_add_box__seq-item {\n    margin-bottom: 6px;\n    padding: 8px;\n    background: var(--surface-color, #fff);\n    border-radius: 6px;\n    font-size: 11px;\n    border: 1px solid var(--border-color, transparent);\n    border-left: 3px solid var(--brand-primary, #1976d2);\n    color: var(--text-color);\n}\n\n.ex_add_box__seq-item--current {\n    background: color-mix(in srgb, #34c759 16%, var(--surface-color, #fff));\n    border: 2px solid #34c759;\n    border-left: 4px solid #34c759;\n    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.25);\n}\n\n.ex_add_box__seq-item-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n    gap: 8px;\n}\n\n.ex_add_box__seq-item-label {\n    font-weight: 500;\n    color: var(--brand-primary, #1976d2);\n}\n\n.ex_add_box__seq-item--current .ex_add_box__seq-item-label,\n.ex_add_box__seq-item--current .ex_add_box__seq-item-meta {\n    color: #34c759;\n    font-weight: 600;\n}\n\n.ex_add_box__seq-item-meta {\n    color: var(--text-secondary, #666);\n}\n\n.ex_add_box__seq-item-roles {\n    display: flex;\n    gap: 8px;\n    font-size: 10px;\n    color: var(--text-secondary, #666);\n}\n\n.ex_add_box__seq-item-roles strong {\n    color: var(--text-color);\n}\n\n.ex_add_box__player-chips {\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--text-secondary);\n}\n\n.ex_add_box__player-chips-row {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.ex_add_box__player-chip {\n    padding: 2px 6px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: var(--text-color);\n}\n\n.ex_add_box__player-chip--a {\n    background: color-mix(in srgb, var(--brand-primary, #1976d2) 16%, var(--surface-color));\n}\n\n.ex_add_box__player-chip--b {\n    background: color-mix(in srgb, #9c27b0 16%, var(--surface-color));\n}\n\n@media(max-width:850px) {\n\n    .session_add_box,\n    .ex_add_box {\n        width: calc(80% - 20px);\n    }\n\n    .ex_menu_options {\n        flex-direction: row;\n\n    }\n\n\n}\n\n@media(max-width:750px) {\n    .ex_add_box {\n        gap: 20px;\n        width: 87%;\n\n    }\n\n    .ex_up_box {\n        gap: 40px;\n    }\n\n    .ex_menu_options {\n        flex-direction: column;\n        gap: 4px;\n\n    }\n\n}\n\n@media(max-width:500px) {\n    .exercise-started {\n        margin: 20px 10px;\n\n    }\n\n    .exercise_add_center {\n        width: 0\n    }\n\n    .add_button {\n        min-width: 50px;\n        font-size: 12px;\n    }\n\n    .table_ex_name {\n        width: 100%\n    }\n\n    .session_add_box,\n    .ex_add_box {\n        width: calc(100% - 20px)\n    }\n\n\n    .exercise_session_div {\n        flex-direction: column;\n    }\n\n}\n\n@media(max-width:400px) {\n    .ex_up_box {\n        gap: 20px;\n    }\n\n    .ex-image-add>img {\n        width: 30px;\n    }\n\n    .exercise_types {\n        font-size: 12px;\n    }\n\n    .exercise_info {\n        margin-right: 0;\n    }\n\n    .ex_add_box {\n        gap: 30px;\n        height: max-content;\n    }\n\n}\n\n@media(max-width:300px) {\n    .exercise_types {\n        flex-direction: column;\n    }\n}\n\n/* ------------------------------------------------------------------------\n   Brand color overrides for Planning page action buttons (MUI)\n   ------------------------------------------------------------------------ */\n.coach-session-page .MuiButton-contained {\n    background-color: var(--brand-primary, #0877BC) !important;\n    color: #fff !important;\n}\n\n.coach-session-page .MuiButton-contained:hover {\n    background-color: var(--brand-primary-dark, #065a8f) !important;\n}\n\n.coach-session-page .MuiButton-contained.Mui-disabled {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;\n    color: rgba(255, 255, 255, 0.85) !important;\n}\n\n.coach-session-page .MuiButton-outlined {\n    border-color: var(--brand-primary, #0877BC) !important;\n    color: var(--brand-primary, #0877BC) !important;\n}\n\n.coach-session-page .MuiButton-outlined:hover {\n    border-color: var(--brand-primary-dark, #065a8f) !important;\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;\n}\n\n.coach-session-page .MuiButton-text {\n    color: var(--brand-primary, #0877BC) !important;\n}\n\n.coach-session-page .MuiButton-text:hover {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;\n}\n\n/* ========================================================================\n   Redesigned Exercise Page - Card-based Layout\n   ======================================================================== */\n\n.expage-nav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 16px;\n    gap: 12px;\n}\n\n.expage-nav__breadcrumb {\n    font-size: 13px;\n    color: #0877BC;\n    font-weight: 500;\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.expage-nav__actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n.expage-nav__count {\n    font-size: 13px;\n    color: #546e7a;\n    font-weight: 600;\n    background: #e8f4fc;\n    padding: 4px 10px;\n    border-radius: 12px;\n}\n\n.expage-nav__add-btn {\n    background-color: #0877BC;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 8px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.expage-nav__add-btn:hover {\n    background-color: #065a8c;\n}\n\n/* Theme sort selector (add-exercise list) */\n.expage-theme-sort {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 0 16px 12px;\n}\n\n.expage-theme-sort__label {\n    font-size: 12px;\n    font-weight: 650;\n    color: var(--text-secondary, #546e7a);\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n}\n\n.expage-theme-sort__chips {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 8px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    padding-bottom: 2px;\n}\n\n.expage-theme-sort__chips::-webkit-scrollbar {\n    display: none;\n}\n\n.expage-theme-sort__chip {\n    flex: 0 0 auto;\n    min-height: 36px;\n    padding: 7px 14px;\n    border-radius: 999px;\n    border: 1px solid var(--border-color, #cfd8dc);\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #202226);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,\n        transform 0.15s ease;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.expage-theme-sort__chip:active {\n    transform: scale(0.97);\n}\n\n.expage-theme-sort__chip:focus-visible {\n    outline: 2px solid var(--brand-primary, #0877bc);\n    outline-offset: 2px;\n}\n\n.expage-theme-sort__chip--active {\n    background: var(--brand-primary, #0877bc);\n    border-color: var(--brand-primary, #0877bc);\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n}\n\n.excard-badge--theme-highlight {\n    box-shadow: 0 0 0 2px var(--brand-primary, #0877bc);\n    font-weight: 700;\n}\n\n.expage-recommend-hint {\n    font-size: 12px;\n    color: var(--text-secondary, #78909c);\n    margin: 0 16px 8px;\n    font-style: italic;\n}\n\n.expage-grid {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 6px;\n    gap: 0;\n}\n\n/* ── Exercise Card ─────────────────────────────────── */\n.excard {\n    width: calc(50% - 20px);\n    margin: 8px 10px;\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #1a2b3c);\n    border-radius: 14px;\n    border: 2px solid transparent;\n    box-shadow: 0 2px 10px var(--shadow-color, rgba(8, 119, 188, 0.08));\n    cursor: pointer;\n    transition: border-color 0.2s, box-shadow 0.25s, transform 0.15s;\n    overflow: hidden;\n}\n\n.excard:hover {\n    box-shadow: 0 4px 16px var(--shadow-color, rgba(8, 119, 188, 0.14));\n    transform: translateY(-1px);\n}\n\n.excard--selected {\n    border-color: var(--brand-primary, #0877BC);\n    background: linear-gradient(\n      135deg,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 0%,\n      var(--surface-color, #fff) 40%\n    );\n    box-shadow: 0 4px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n}\n\n/* Header */\n.excard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 14px 14px 10px;\n    gap: 10px;\n}\n\n.excard-header__left {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n}\n\n.excard-header__img {\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: color-mix(in srgb, var(--text-color, #1a2b3c) 6%, var(--surface-color, #f5f8fa));\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.excard-header__img--mark {\n    width: 56px;\n    height: 56px;\n    border-radius: 14px;\n    padding: 3px;\n    box-sizing: border-box;\n    background: color-mix(\n        in srgb,\n        var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,\n        #ffffff\n    );\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);\n}\n\n.dark-mode .excard-header__img--mark,\nhtml[data-theme=\"dark\"] .excard-header__img--mark {\n    background: color-mix(\n        in srgb,\n        var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,\n        #1f2937\n    );\n}\n\n.excard-header__img img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.excard-header__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.excard-header__name {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--text-color, #1a2b3c);\n    margin: 0 0 4px;\n    line-height: 1.3;\n    word-wrap: break-word;\n}\n\n.excard-header__desc {\n    font-size: 12px;\n    color: var(--text-secondary, #607d8b);\n    line-height: 1.4;\n    margin: 0 0 6px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.excard-header__type-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    align-items: center;\n}\n\n.excard-header__right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.excard-header__duration {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.excard-header__duration-icon {\n    color: var(--text-secondary, #90a4ae);\n    flex-shrink: 0;\n}\n\n.excard-header__duration-input {\n    width: 40px;\n    padding: 3px 5px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 6px;\n    font-size: 13px;\n    text-align: center;\n    outline: none;\n    transition: border-color 0.2s;\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #1a2b3c);\n}\n\n.excard-header__duration-input:focus {\n    border-color: var(--brand-primary, #0877BC);\n    background: var(--bg-color, #f8fcff);\n}\n\n.excard-header__duration-unit {\n    font-size: 12px;\n    color: var(--text-secondary, #90a4ae);\n}\n\n.excard-header__select-btn {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid var(--border-color, #cfd8dc);\n    border-radius: 8px;\n    background: var(--surface-color, #fff);\n    color: var(--text-secondary, #90a4ae);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.excard-header__select-btn svg {\n    font-size: 18px;\n}\n\n.excard-header__select-btn--active {\n    border-color: #0877BC;\n    background: #0877BC;\n    color: #fff;\n}\n\n/* Tags (Type / Subtype / Cardio) */\n.excard-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    padding: 2px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.4;\n}\n\n.excard-tag--type {\n    background: #e3f2fd;\n    color: #1565c0;\n}\n\n.excard-tag--subtype {\n    background: color-mix(in srgb, var(--brand-secondary, #2E7D32) 16%, #fff);\n    color: color-mix(in srgb, var(--brand-secondary, #2E7D32) 82%, black);\n    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 44%, transparent);\n}\n\n.excard-tag--cardio {\n    background: #fff3e0;\n    color: #e65100;\n    gap: 4px;\n}\n\n.excard-tag--cb {\n    background: color-mix(in srgb, var(--brand-secondary, #2E7D32) 22%, #fff);\n    color: color-mix(in srgb, var(--brand-secondary, #2E7D32) 85%, black);\n    border: 1px solid color-mix(in srgb, var(--brand-secondary, #2E7D32) 50%, transparent);\n}\n\n/* Sections (Objective, Focus) */\n.excard-section {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 0 14px 8px;\n}\n\n.excard-section__icon {\n    font-size: 16px !important;\n    color: var(--text-secondary, #78909c);\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.excard-section--objective .excard-section__icon {\n    color: #1565c0;\n}\n\n.excard-section--focus .excard-section__icon {\n    color: #e65100;\n}\n\n.excard-section__text {\n    font-size: 12px;\n    color: var(--text-secondary, #546e7a);\n    line-height: 1.5;\n    margin: 0;\n}\n\n.excard-section--objective .excard-section__text {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.excard-section__focus-item {\n    margin: 0 0 2px;\n    padding-left: 10px;\n    position: relative;\n    font-size: 12px;\n    color: var(--text-secondary, #546e7a);\n    line-height: 1.5;\n}\n\n.excard-section__focus-item::before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    color: #e65100;\n    font-weight: 700;\n}\n\n/* Rows (Themes, Skills, Focus) */\n.excard-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 0 14px 8px;\n}\n\n.excard-row__icon {\n    font-size: 15px !important;\n    color: var(--text-secondary, #78909c);\n    margin-top: 3px;\n    flex-shrink: 0;\n}\n\n.excard-row--themes .excard-row__icon {\n    color: #5c6bc0;\n}\n\n.excard-row--skills .excard-row__icon {\n    color: #26a69a;\n}\n\n.excard-row--focus .excard-row__icon {\n    color: #e65100;\n}\n\n.excard-row__badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n/* Badges */\n.excard-badge {\n    display: inline-flex;\n    align-items: center;\n    font-size: 10px;\n    font-weight: 600;\n    border-radius: 10px;\n    overflow: hidden;\n    line-height: 1.2;\n}\n\n.excard-badge--theme {\n    border: 1.5px solid #90caf9;\n    background: #f5f8fc;\n}\n\n.excard-badge--theme .excard-badge__label {\n    padding: 2px 6px;\n    color: #37474f;\n}\n\n.excard-badge--theme .excard-badge__level {\n    padding: 2px 6px;\n    color: #fff;\n    font-weight: 700;\n    font-size: 10px;\n}\n\n.excard-badge--skill {\n    background: #e0f2f1;\n    color: #00695c;\n    padding: 3px 8px;\n    border: 1px solid #b2dfdb;\n}\n\n.excard-badge--focus {\n    background: #fff3e0;\n    color: #bf360c;\n    padding: 3px 8px;\n    border: 1px solid #ffcc80;\n}\n\n/* Cardio dots */\n.excard-cardio {\n    display: flex;\n    gap: 2px;\n    align-items: center;\n}\n\n.excard-cardio__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #e0e0e0;\n    transition: background-color 0.2s;\n}\n\n.excard-cardio__dot--filled {\n    background: #ff9800;\n}\n\n/* Expandable instruction */\n.excard-expand {\n    border-top: 1px solid var(--border-color, #f0f0f0);\n    margin: 0 14px;\n    padding: 6px 0 10px;\n}\n\n.excard-expand__toggle {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: none;\n    border: none;\n    color: var(--brand-primary, #0877BC);\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 2px 0;\n}\n\n.excard-expand__toggle:hover {\n    text-decoration: underline;\n}\n\n.excard-expand__content {\n    font-size: 12px;\n    color: var(--text-secondary, #546e7a);\n    line-height: 1.6;\n    margin: 6px 0 0;\n    padding: 8px 10px;\n    background: var(--bg-color, #f8fafb);\n    border-radius: 8px;\n    border-left: 3px solid var(--brand-primary, #0877BC);\n}\n\n/* ── Responsive ─────────────────────────────────────── */\n@media (max-width: 900px) {\n    .excard {\n        width: calc(100% - 20px);\n    }\n}\n\n@media (max-width: 500px) {\n    .expage-nav {\n        flex-wrap: wrap;\n        padding: 8px 10px;\n    }\n\n    .expage-nav__breadcrumb {\n        width: 100%;\n        margin-bottom: 4px;\n    }\n\n    .expage-grid {\n        padding: 0 2px;\n    }\n\n    .excard {\n        width: calc(100% - 8px);\n        margin: 6px 4px;\n    }\n\n    .excard-header {\n        padding: 10px 10px 8px;\n        flex-wrap: wrap;\n    }\n\n    .excard-header__right {\n        flex-direction: row;\n        align-items: center;\n        width: 100%;\n        justify-content: flex-end;\n        margin-top: 4px;\n    }\n\n    .excard-section,\n    .excard-row,\n    .excard-expand {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .excard-expand {\n        margin: 0 10px;\n    }\n\n    .excard-header__name {\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
